export default __webpack_public_path__ + "static/media/bookmark_white.06d1bf18.svg";